<template>
  <v-container>
    <v-row justify="center">
      <v-col cols="12">
        <!-- <div>
          <v-btn @click="SignOut()">登出</v-btn>
        </div>
        <div>使用者 : {{ username }}</div>
        <v-btn @click="Token_UsernameApi()">Get使用者</v-btn> -->
        <div class="text-h5 font-weight-black my-2">
          {{ isDialog ? "登入小芋頭" : componentData.title }}
        </div>
      </v-col>
      <v-col>
        <!-- 對話框：Google 放最上面（登入頁照舊放在登入按鈕下面） -->
        <template v-if="isDialog">
          <v-btn block large outlined class="btn-gray-border" :loading="componentData.googleLoading" @click="GoogleSignupWithRefAPI()">
            <v-img contain max-height="22.8" max-width="24" :src="componentData.googleLogo"></v-img>
            <span class="mx-2 text-capitalize">以 Google 帳號繼續</span>
          </v-btn>
          <div class="d-flex align-center my-5">
            <v-divider></v-divider>
            <span class="mx-3 text-body-2 text--disabled">{{ componentData.or }}</span>
            <v-divider></v-divider>
          </div>
        </template>
        <!-- 切換帳號帶過來的說明（例如「這個帳號用 Google 登入」） -->
        <div v-if="notice" class="d-flex align-start mb-4 pa-2 rounded blue lighten-5 text-left text-body-2">
          <v-icon small color="blue darken-2" class="mr-2 mt-1">mdi-information-outline</v-icon>
          <span>{{ notice }}</span>
        </div>
        <v-form ref="form" v-model="componentData.formSetting.valid" lazy-validation>
          <v-text-field
            outlined
            hide-details="auto"
            v-model="signInData.email"
            name="email"
            type="email"
            autocomplete="username"
            :label="componentData.formSetting.input1.label"
            :placeholder="componentData.formSetting.input1.placeholder"
            :rules="componentData.formSetting.input1.rules"
            :error-messages="componentData.formSetting.input1.errorMsg"
            @focus="ResetValidation"
          ></v-text-field>
          <div class="py-2"></div>
          <v-text-field
            outlined
            hide-details="auto"
            v-model="signInData.password"
            name="password"
            autocomplete="current-password"
            :label="componentData.formSetting.input2.label"
            :placeholder="componentData.formSetting.input2.placeholder"
            :rules="componentData.formSetting.input2.rules"
            :error-messages="componentData.formSetting.input2.errorMsg"
            :type="pwdVisiable ? 'text' : 'password'"
            :append-icon="pwdVisiable ? eyeIcon.eyeOff : eyeIcon.eyeOn"
            @keyup.enter="SignIn()"
            @click:append="EyeSwitch()"
            @focus="ResetValidation"
          ></v-text-field>
        </v-form>
        <div class="d-flex justify-space-between align-center mt-1">
          <v-checkbox v-model="rememberPwd" hide-details class="ma-0" dense>
            <template v-slot:label>
              <div class="text-body-2">記住帳號密碼</div>
            </template>
          </v-checkbox>
          <v-btn text color="deep-purple accent-3" class="pa-0 text-decoration-underline" plain @click="GoResetPwd()">
            {{ componentData.forgotPwd }}
          </v-btn>
        </div>
        <!-- 勾了才出現：密碼存在哪、什麼裝置不要勾（見 utils/savedLogin.js） -->
        <v-expand-transition>
          <div v-if="rememberPwd" class="remember-hint d-flex align-start mt-1 pa-2 rounded orange lighten-5 text-left">
            <v-icon small color="orange darken-3" class="remember-hint__icon mr-2">mdi-shield-alert-outline</v-icon>
            <div class="remember-hint__text text--primary">
              <span class="font-weight-bold orange--text text--darken-4">僅限個人裝置勾選：</span>{{ rememberHint }}
            </div>
          </div>
        </v-expand-transition>
        <div class="text-caption text--secondary mt-4">
          本網站採用reCAPTCHA 保護機制
          <a href="https://policies.google.com/privacy">隱私權</a>
          &
          <a href="https://policies.google.com/terms">條款</a>
          <div v-show="false">
            This site is protected by reCAPTCHA and the Google
            <a href="https://policies.google.com/privacy">Privacy Policy</a>
            and
            <a href="https://policies.google.com/terms">Terms of Service</a>
            apply.
          </div>
        </div>

        <div class="py-4"></div>
        <v-btn block large color="primary" :loading="componentData.loading" @click="SignIn()">
          <span class="mx-2 text-capitalize">{{ componentData.login }}</span>
        </v-btn>

        <template v-if="!isDialog">
          <v-row class="d-flex">
            <v-col cols="6">
              <v-divider class="my-10"></v-divider>
            </v-col>
            <div class="my-11 body-2 text--disabled">
              {{ componentData.or }}
            </div>
            <v-col>
              <v-divider class="my-10"></v-divider>
            </v-col>
          </v-row>

          <v-btn block large outlined class="btn-gray-border" :loading="componentData.googleLoading" @click="GoogleSignupWithRefAPI()">
            <v-img contain max-height="22.8" max-width="24" :src="componentData.googleLogo"></v-img>
            <span class="mx-2 text-capitalize">{{ componentData.googleLogin }}</span>
          </v-btn>
        </template>

        <!-- <div class="py-4"></div>
         <v-btn
          block
          large
          color="primary"
          :loading="componentData.loading"
          @click="SignIn()"
        >
          <span class="mx-2 text-capitalize">{{ componentData.login }}</span>
        </v-btn> -->
        <div class="py-4"></div>
        <div class="d-flex justify-center align-center mt-4">
          <div class="text-body-1 mr-2">{{ componentData.noAcc }}</div>

          <v-btn color="primary" class="px-2 text-body-2" height="30" outlined @click="GoSignUp()">
            {{ componentData.freeSignup }}
          </v-btn>
        </div>
      </v-col>
    </v-row>

    <!-- #region AI聊天ifrom -->
    <!-- <iframe
      id="aichat"
      ref="aichat"
      :src="serivces.aichat"
      style="display: none"
    ></iframe> -->
    <!-- #endregion -->
  </v-container>
</template>

<script>
import { Token_SignIn, Google_Login, Google_GetSiteToken, Token_LogOut, Token_Username } from "@/apis/api";
import axios from "axios";
import { redirectIfHasSavedUrl } from "@/utils/redirectHelper";
import { withGoogleAccountChooser } from "@/utils/googleAuthUrl";
import { canUseAppAuth, openGoogleAuth } from "@/utils/nativeApp";
import { hasSecureCredentialStore, loadSavedLogin, rememberLogin } from "@/utils/savedLogin";
import { finishGooglePopup, isGooglePopupLanding, startGoogleLogin } from "@/utils/googlePopup";
import { markLoginMethod } from "@/utils/knownAccounts";

export default {
  name: "SignIn",
  // 內嵌在社群、AI 站對話框時（views/EmbedLogin.vue）：整頁跳轉要換外層的頁面、回到外層的網址
  inject: { embedHost: { default: null } },
  props: {
    // page：登入頁（views/SignIn.vue）；dialog：登入對話框（components/Common/LoginDialog.vue），登入完留在原頁面
    mode: { type: String, default: "page" },
    // 對話框：登入完要前往的站內路徑（Google 登入整頁跳轉回來時也導到這裡）
    after: { type: String, default: null },
    // 切換帳號（utils/accountSwitch.js）：帶入這個帳號／什麼都不帶入／表單上方的說明
    presetEmail: { type: String, default: null },
    blank: { type: Boolean, default: false },
    notice: { type: String, default: null },
  },
  data() {
    return {
      loginStatus: "",
      username: "",
      token: "",
      // 預設：App（自己的手機）勾；網頁上次有勾才勾（公用電腦不要預設幫人記）
      rememberPwd: hasSecureCredentialStore() || localStorage.getItem("_acc") !== null,
      componentData: {
        title: "會員登入",
        formSetting: {
          valid: true,
          input1: {
            label: "帳號(電子信箱)",
            placeholder: "email",
            rules: [(v) => !!v || "此欄位必填", (v) => /^\w+((-\w+)|(\.\w+)|(\+\w+))*@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z]+$/.test(v) || "格式錯誤，請重新輸入"],
            errorMsg: "",
          },
          input2: {
            label: "密碼",
            placeholder: "請輸入",
            rules: [(v) => !!v || "此欄位必填", (v) => v?.length >= 6 || "長度最少需為6個字元", (v) => v?.length <= 20 || "長度需少於20個字元", (v) => /^[a-zA-Z0-9~!@#$%&_?]+$/.test(v) || "密碼格式錯誤"],
            errorMsg: "",
          },
        },
        forgotPwd: "忘記密碼?",
        or: "或",
        googleLogo: require("@/assets/image/components/Google Icon.svg"),
        googleLogin: "Google 登入",
        login: "登入",
        noAcc: "還沒有小芋頭帳號?",
        freeSignup: "免費註冊",
        loading: false,
        googleLoading: false,
      },
      signInData: {
        email: null,
        password: null,
        recaptchaToken: "",
      },
      pwdVisiable: false,
      eyeIcon: {
        eyeOn: "mdi-eye",
        eyeOff: "mdi-eye-off",
      },
      serivces: {
        sms: process.env.VUE_APP_MAIN_SMS_BASE_URL,
        wt: process.env.VUE_APP_MAIN_WT_BASE_URL,
        aichat: process.env.VUE_APP_MAIN_AICHAT_BASE_URL + "/listener",
      },
    };
  },
  computed: {
    isDialog() {
      return this.mode === "dialog";
    },
    rememberHint() {
      // 最多兩行（手機寬度也是）：前面接粗體「僅限個人裝置勾選：」
      return hasSecureCredentialStore()
        ? "帳號密碼加密存在這支手機，共用的手機請勿勾選。"
        : "密碼由瀏覽器加密保存，公用電腦請勿勾選，用完記得登出。";
    },
  },
  watch: {},
  beforeDestroy() {
    // 對話框關了：不再等 Google 小視窗的結果
    if (this.googleFlow) this.googleFlow.cancel();
  },
  created() {
    this.componentData.loading = true;
    this.componentData.googleLoading = true;

    // 測試登入狀態
    this.loginStatus = this.$store.state.signinStatus;
    this.username = this.$store.state.username;
  },
  mounted() {
    setTimeout(() => {
      this.componentData.loading = false;
      this.componentData.googleLoading = false;
    }, 500);

    // 對話框只做登入表單本身：推薦碼、社群邀請、Google 轉回來、已登入自動導走，都是登入頁才有的事
    if (this.isDialog) {
      // 切換帳號：只帶入那個帳號，不帶入記住的密碼（App 切換時已經試過了，走到這裡代表不能用）；
      // 網頁的密碼交給瀏覽器的密碼管理員依帳號填
      if (this.presetEmail) this.signInData.email = this.presetEmail;
      else if (!this.blank) this.FillSavedLogin();
      return;
    }

    // 登入對話框開的 Google 小視窗，在 Google 按了取消會被帶回登入頁：告訴原視窗、關掉自己（見 utils/googlePopup.js）
    if (isGooglePopupLanding() && this.$route.query.guid === undefined) finishGooglePopup(false);

    // AI平台前端過來得分享會員emailCode
    if (this.$route.query.refc) {
      const raw = this.$route.query.refc;
      const refc = Array.isArray(raw) ? raw[0] : raw;
      localStorage.setItem("referral_code", refc);
    } else {
      localStorage.removeItem("referral_code");
    }

    // 小芋頭社群邀請
    if (this.$route.query.ivtem) {
      localStorage.setItem("inviterQuery", `cmid=${this.$route.query.cmid}&ivtem=${this.$route.query.ivtem}`);
      localStorage.setItem("inviterEmail", this.$route.query.ivtem);
    } else {
      localStorage.removeItem("inviterQuery");
      localStorage.removeItem("inviterEmail");
    }

    var guid = this.$route.query.guid;

    // 其實已經登入了（進這頁之前，路由已經用 Cookie 靜默登入成功）：不用再輸入密碼，直接走登入成功後的導向。
    // 常見情境：社群、AI 站自己的登入狀態不見了，把人送來這裡 —— 平台這邊其實還登入著
    const signedInToken = localStorage.getItem("_token");
    if (guid === undefined && this.$store.state.signinStatus && this.$store.state.username && signedInToken) {
      this.componentData.loading = true;
      this.GoFromSite(this.$store.state.username, signedInToken);
      return;
    }

    this.FillSavedLogin();

    // Google登入轉址回來要從快取拿token需要的Guid存sessionStorage
    if (guid !== undefined) {
      // Guid塞進sessionStorage
      sessionStorage.setItem("_guid", guid);
      // 用Guid拿暫存在快取的token
      this.GetSiteToken(guid);
    }

    // this.checkIframeLoaded();
  },
  methods: {
    // 記住帳號密碼：App 從手機的 Keystore 帶入；網頁帶入帳號，密碼由瀏覽器的密碼管理員填。
    // 舊版明文存的密碼（_pwd）帶入一次後搬到安全的地方，使用者不用重新輸入（見 utils/savedLogin.js）
    FillSavedLogin() {
      loadSavedLogin().then(({ email, password }) => {
        if (email && !this.signInData.email) this.signInData.email = email;
        if (password && !this.signInData.password) this.signInData.password = password;
      });
    },
    /** 對話框裡按 Google：整頁跳去 Google，回來時（登入頁的 redirectIfHasSavedUrl）導回原本這一頁 */
    RememberReturnForGoogle() {
      if (this.isDialog) localStorage.setItem("redirectAfterLogin", this.after || window.location.href);
    },
    // 先check iframe已經load完
    checkIframeLoaded() {
      // 先load iframe.addEventListener
      const iframe = this.$refs.aichat;
      if (iframe.contentDocument && iframe.contentDocument.readyState === "complete") {
        console.log("Iframe already loaded.");
        this.componentData.loading = false;
        this.componentData.googleLoading = false;
      } else {
        iframe.addEventListener("load", () => {
          console.log("Iframe loaded.");
          this.componentData.loading = false;
          this.componentData.googleLoading = false;
        });
      }
    },
    // 顯示密碼切換
    EyeSwitch() {
      this.pwdVisiable = !this.pwdVisiable;
    },
    // 清除表單驗證
    ResetValidation() {
      // this.$refs.form.resetValidation();
      this.componentData.formSetting.input1.errorMsg = "";
      this.componentData.formSetting.input2.errorMsg = "";
    },
    // 平台登入取回token
    async SignIn() {
      this.$refs.form.validate();
      if (!this.$refs.form.validate()) return false;
      this.componentData.loading = true;
      this.signInData.recaptchaToken = await this.GetRecaptchaToken();
      this.signInData.refc = localStorage.getItem("referral_code") || localStorage.getItem("inviterEmail") || null;
      localStorage.removeItem("_token");
      // API
      Token_SignIn(this.signInData)
        .then(async (res) => {
          localStorage.setItem("_token", res.data.token);
          // 「切換帳號」清單記下這個帳號用帳密登入（utils/knownAccounts.js）
          markLoginMethod("password");
          // 勾了：App 存進手機的 Keystore、網頁請瀏覽器儲存；沒勾：清掉（見 utils/savedLogin.js）
          rememberLogin(this.rememberPwd, this.signInData.email, this.signInData.password);

          // 對話框：更新全站登入狀態，留在原頁面（LoginDialog 收尾）
          if (this.isDialog) {
            await this.$store.dispatch("GetEmailEncrypt");
            this.componentData.loading = false;
            this.$emit("signed-in");
            return;
          }

          this.GetEmailEncrypt(res.data.token);
          this.$emit("token", res.data.token);
        })
        .catch((err) => {
          console.log(err);
          const errorMsg = err.response?.data?.message || err.message || "登入失敗，請檢查網路連線";
          
          if (errorMsg === "密碼錯誤，請重新輸入") {
            this.componentData.formSetting.input2.errorMsg = errorMsg;
          } else {
            this.componentData.formSetting.input1.errorMsg = errorMsg;
          }

          this.componentData.loading = false;
        });
    },
    // Google 登入
    GoogleSignIn() {
      this.componentData.googleLoading = true;
      this.RememberReturnForGoogle();
      localStorage.removeItem("_token");
      // App 裡改用系統瀏覽器分頁開 Google（Google 不允許在 App 內嵌的網頁視窗登入）
      Google_Login(canUseAppAuth())
        .then((res) => openGoogleAuth(withGoogleAccountChooser(res.data)))
        .then(() => {
          this.componentData.googleLoading = false;
        })
        .catch((err) => {
          console.log(err);
          this.componentData.googleLoading = false;
        });
    },
    // Google 登入註冊帶推薦人。對話框（電腦版）開小視窗、登入完留在原頁面；其他情況整頁跳轉（見 utils/googlePopup.js）
    GoogleSignupWithRefAPI() {
      const referred = localStorage.getItem("referral_code");
      const inviterEmail = localStorage.getItem("inviterEmail");
      this.componentData.googleLoading = true;
      const flow = startGoogleLogin({
        refc: referred ?? inviterEmail,
        popup: this.isDialog,
        returnUrl: this.embedHost ? this.embedHost.returnUrl : this.isDialog ? this.after || window.location.href : null,
        navigate: this.embedHost ? this.embedHost.navigateTop : null,
        onIdle: () => {
          this.componentData.googleLoading = false;
        },
      });
      this.googleFlow = flow;
      flow.promise
        .then(async (result) => {
          if (result === "signed-in") {
            await this.$store.dispatch("GetEmailEncrypt");
            this.$emit("signed-in");
          }
          this.componentData.googleLoading = false;
        })
        .catch((err) => {
          console.log(err);
          this.componentData.googleLoading = false;
        });
    },
    // Google 驗證 recaptcha v3
    async GetRecaptchaToken() {
      // 原生 App（Capacitor WebView）無法執行 reCAPTCHA（會被沙箱擋住而 timeout），
      // 改由後端以 App 專屬 User-Agent 標記略過驗證，這裡直接回傳標記避免卡住。
      if (window.Capacitor && window.Capacitor.isNativePlatform && window.Capacitor.isNativePlatform()) {
        return "APP_NATIVE";
      }
      await this.$recaptchaLoaded();
      const token = await this.$recaptcha("login");
      return token;
    },
    // 用guid換token
    GetSiteToken(letter) {
      localStorage.removeItem("_token");
      Google_GetSiteToken(letter)
        .then((res) => {
          localStorage.setItem("_token", res.data.token);
          markLoginMethod("google");
          this.GetEmailEncrypt(res.data.token);
          this.$emit("token", res.data.token);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 取得加密email
    GetEmailEncrypt(token) {
      const apiBaseUrl = process.env.VUE_APP_MAIN_API_BASE_URL;
      const header = {
        Authorization: "Bearer " + token,
      };
      const myRequest = axios.create({
        baseURL: apiBaseUrl,
        headers: header,
      });
      myRequest
        .get(`Token/emailEncrypt`)
        .then((res) => {
          console.log(res);
          this.username = res.data;
          localStorage.setItem("_emailEncrypt", res.data);

          setTimeout(() => {
            this.GoFromSite(res.data, token);
            this.componentData.loading = false;
          }, 1000);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 從哪來回哪去
    GoFromSite(emailEncrypt, token) {
      // 1. 如果有 redirectIfHasSavedUrl (手動存的回跳位址) 就導回，該方法已內含 t 附加邏輯
      if (redirectIfHasSavedUrl(emailEncrypt, token)) return;

      // 2. 獲取來源站台的基礎 URL (從 Vuex 取得)
      let targetUrl = this.$store.state.fromSite.url;
      if (!targetUrl) {
         console.warn("No fromSite URL found, fallback to Home");
         this.GoBackHome();
         return;
      }

      // 3. 處理特殊路徑 (例如社群填寫表單)
      let path = "";
      let additionalParams = {};

      if (this.$route.query.ivtem) {
        path = "/writeInvitedForm";
        additionalParams = {
          cmid: this.$route.query.cmid,
          ivtem: this.$route.query.ivtem
        };
      } else if (localStorage.getItem("inviterQuery")) {
        path = "/writeInvitedForm";
        // 解析存好的 query string
        const savedQuery = new URLSearchParams(localStorage.getItem("inviterQuery"));
        localStorage.removeItem("inviterQuery");
        savedQuery.forEach((value, key) => { additionalParams[key] = value; });
      } else if (localStorage.getItem("fromCmid")) {
        path = "/writeInvitedForm";
        additionalParams = { cmid: localStorage.getItem("fromCmid") };
        localStorage.removeItem("fromCmid");
      } else if (this.$store.state.fromSite.en.toLowerCase() === "aichat" && this.$route.query.p) {
        path = "/pre-order";
      }

      // 4. 構建最終 URL
      try {
        const u = new URL(targetUrl + path);
        // 一律附加基本參數，確保各容器 (如 iOS PWA) 都能接收到
        u.searchParams.set("emailEncrypt", emailEncrypt);
        u.searchParams.set("t", token);
        
        // 附加額外參數
        Object.keys(additionalParams).forEach(key => {
          u.searchParams.set(key, additionalParams[key]);
        });

        console.log("🚀 Redirecting to:", u.toString());
        window.location.href = u.toString();
      } catch (e) {
        console.error("URL Build Error:", e);
        window.location.href = targetUrl; // 失敗時保底跳回站台首頁
      }
    },
    // 回平台首頁
    GoBackHome() {
      this.$router.push({ name: "Home" });
    },
    // 轉註冊頁面
    GoSignUp() {
      this.$emit("switch", "SignUp");
    },
    // 轉重設密碼頁面
    GoResetPwd() {
      this.$emit("switch", "ResetPwd");
    },
    //登出
    SignOut() {
      Token_LogOut()
        .then((res) => {
          console.log(res);
          //     this.$router.go(0);
        })
        .catch();
      //   localStorage.setItem("_token", null);
      //   setTimeout(() => {
      //     this.$router.go(0);
      //   }, 1000);
    },
    Token_UsernameApi() {
      Token_Username()
        .then((res) => {
          console.log(res);
          this.username = res.data;
        })
        .catch((err) => {
          console.log(err.response);
        });
    },
  },
};
</script>

<style scoped>
.remember-hint__text {
  font-size: 13px;
  line-height: 1.5;
}
.remember-hint__icon {
  margin-top: 2px;
}
</style>
